import styled from '@emotion/styled'
import CancelIcon from '@mui/icons-material/Cancel'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

import { Section, Space } from '../../atoms'
import { Attribute } from '../../molecules/attribute'

type Strategy = {
  isAvailable: boolean
  name: string
}

export type StrategyDisplayProps = {
  strategies: Strategy[]
}

const StyledWrapper = styled.div`
  width: 100%;
`

const Available = styled.div`
  color: var(--Success);
`

const Unavailable = styled.div`
  color: var(--Graphite);
`

const Icon = styled.div`
  width: 20px;
  height: 20px;
  svg {
    width: 20px;
    height: 20px;
  }
`

export function StrategyDisplay({ strategies }: StrategyDisplayProps) {
  return (
    <StyledWrapper>
      <Section type="primary">
        <Space isflex flexDirection="column">
          {strategies.map(strategy => (
            <Attribute key={strategy.name} name={strategy.name}>
              {strategy.isAvailable ? (
                <Available>
                  <Space isflex alignItems="center">
                    <Space mr={2}>Available</Space>
                    <Icon>
                      <CheckCircleIcon />
                    </Icon>
                  </Space>
                </Available>
              ) : (
                <Unavailable>
                  <Space isflex alignItems="center">
                    <Space mr={2}>Unavailable</Space>
                    <Icon>
                      <CancelIcon />
                    </Icon>
                  </Space>
                </Unavailable>
              )}
            </Attribute>
          ))}
        </Space>
      </Section>
    </StyledWrapper>
  )
}
